import e from "./setPrototypeOf.js";
function p(o, t) {
  o.prototype = Object.create(t.prototype), o.prototype.constructor = o, e(o, t);
}
export { p as default };